export const arisanField: string[] = [
  "name",
  "administrator",
  "dues",
  "payment_term",
  "member_count",
];
